import { Link } from "react-router-dom";

function NotFound(){
    return(
        <main className="text-center">
            <p className="text-3xl pt-20">
                404
            </p>
            <p>Wróć do strony głównej</p>
            <Link className="text-blue-500 underline" to="/">Strona główna</Link>
        </main>
    )
}

export default NotFound;
